<template>
  <tr>
    <td>
      <version-tooltip :version=item.version>
        ({{ item.code }}) {{ item.title }}
      </version-tooltip>
    </td>
    <td>{{ item.price | currency }}</td>
    <td>{{ item.externalId }}</td>
    <td>{{ item.hidden ? 'Yes' : 'No'}}</td>
    <td>
        <v-tooltip bottom>
          <span slot="activator" :class="effectiveContractorName.type">
            {{ effectiveContractorName.title }}
          </span>
          <span>
            {{ effectiveContractorName.from }}
          </span>
        </v-tooltip>
    </td>
    <td class="text-right">
      <v-btn flat icon color="black lighten-2" class="mr-0" @click="handleEditClickButton">
        <v-icon small>fas fa-pencil-alt</v-icon>
      </v-btn>
      <v-btn flat icon color="black lighten-2" class="ml-0" @click="handleDeleteButtonClick">
        <v-icon small>fas fa-trash-alt</v-icon>
      </v-btn>
      <confirm ref="confirm"></confirm>
    </td>
  </tr>
</template>

<script>
import api from '../../api'
import {showApiError} from '../../helpers/notification'
import {isNumeric} from '../../helpers/types'
import {validateStringLength} from '../../helpers/validation'
import Confirm from '../Ui/Confirm'
import VersionTooltip from '../Ui/VersionTooltip'
import _ from 'lodash'

export default {
  name: 'client-service-item',
  props: {
    item: {
      type: Object
    },   
    availableContractors: {
      type: Array
    },   
    availableServices: {
      type: Array
    },   
    availableClients: {
      type: Array
    }
  },
  components: {
    Confirm,
    VersionTooltip
  },
  computed: {
    effectiveContractorName(){
      let contractor = _.find(this.availableContractors, c => c.id == this.item.contractorId)
      if (contractor) {
        return {
          title: contractor.title,
          type: 'client-service',
          from: 'Contractor from Service Of Client'
        }
      }

      let client = _.find(this.availableClients, c => c.id == this.item.clientId)
      if (client){
        contractor = _.find(this.availableContractors, c => c.id == client.contractorId)
        if (contractor) {
          return {
          title: contractor.title,
          type: 'client',
          from: 'Contractor from Client'
         }
        }
      }

      let service = _.find(this.availableServices, c => c.id == this.item.serviceId)
      if (!service) {
        return {
          title: '-',
          from: 'Not Found'
        }
      }

      contractor = _.find(this.availableContractors, c => c.id == service.contractorId)
      if (contractor) {
        return {
          title: contractor.title,
          type: 'service',
          from: 'Contractor from Service'
        }
      }
      
      return {
          title: '-',
          from: 'Not Found'
        }
    },
  },
  filters: {},
  data () {
    return {
      validatableRefs: ['price', 'externalId'],
      externalIdRules: [
        _.partial(validateStringLength, _, 255, 'The length of the externalId should be no more than 2000 characters')
      ],
      priceRules: [
        (value) => {
          let numeric = isNumeric(value)

          if (!numeric) {
            return 'Price must be numeric value'
          }

          if (parseFloat(value) < 0) {
            return 'Price value must be positive or zero'
          }

          return true
        }
      ]
    }
  },
  beforeCreate () {

  },
  watch: {},
  mounted () {
  },
  methods: {
    handleEditClickButton () {
      this.$emit('editItem', this.item)
    },
    async handleDeleteButtonClick () {
      this.$refs.confirm.open('Delete client service', `Do you want to remove service from client with title: "${this.item.title}"? Important: the service to be removed should not be present in any cases`, {width: 600}).then(async (confirm) => {
        if (!confirm) {
          return
        }
        try {
          await api.deleteClientService(this.item)
          this.$emit('deleted', this.item)
        } catch (e) {
          showApiError(this, e, 'Unable to delete client service')
        }
      })
    }
  }
}
</script>

<style scoped>
  .client-service {
    color: black;
  }

  .service {
    color: blue
  }

  .client {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ClientServiceItem.vue